import { useState } from 'react'
import axios from '../../lib/axios'
import { useNavigate } from 'react-router-dom'
import { ArrowLeft, Lightbulb, CheckCircle2, Calendar, Mail, Rocket } from 'lucide-react'
import '../Pages.css'

export default function AddMainCampaign() {
  const [campaignName, setCampaignName] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const handleFormSubmit = async (e) => {
    e.preventDefault()

    if (!campaignName || campaignName.trim() === '') {
      alert('Please enter a campaign name')
      return
    }

    setLoading(true)

    const payload = {
      sender_ids: [0],
      email_body: 'Replace Content Here',
      subject: 'Replace Subject line here...',
      campaign_cron_time: new Date().toISOString(),
      master_template_id: 0,
      name: campaignName
    }

    try {
      const response = await axios.post('email-campaign/create', payload)

      if (response.data && response.data.id) {
        navigate(`/campaigns/schedule/${response.data.id}`)
      }
    } catch (error) {
      console.error('Error creating campaign:', error)
      alert('Failed to create campaign. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  const steps = [
    { num: 1, label: 'Name', active: true },
    { num: 2, label: 'Schedule', active: false },
    { num: 3, label: 'Sequence', active: false },
    { num: 4, label: 'Launch', active: false }
  ]

  const tips = [
    { icon: Lightbulb, text: 'Use a descriptive name so you can easily find this campaign later.' },
    { icon: Calendar, text: 'After naming, you\'ll set up the sending schedule for optimal delivery.' },
    { icon: Mail, text: 'Build your email sequence with personalized follow-ups to boost engagement.' },
    { icon: Rocket, text: 'Review everything before launching — you can pause or resume anytime.' }
  ]

  return (
    <div className="page animate-fade-in">
      <div className="page-header">
        <div className="header-info">
          <h2>Create New Campaign</h2>
          <p>Start by giving your campaign a name, then configure the details</p>
        </div>
        <button onClick={() => navigate('/campaigns')} className="btn btn-ghost">
          <ArrowLeft size={18} />
          <span>Back to Campaigns</span>
        </button>
      </div>

      {/* Step Indicators */}
      <div className="campaign-steps">
        {steps.map((step, i) => (
          <div key={step.num} style={{ display: 'flex', alignItems: 'center' }}>
            <div className={`campaign-step${step.active ? ' active' : ''}`}>
              <span className="campaign-step-number">{step.num}</span>
              <span>{step.label}</span>
            </div>
            {i < steps.length - 1 && <div className="campaign-step-connector" />}
          </div>
        ))}
      </div>

      {/* Two-column Layout */}
      <div className="campaign-creation-layout">
        {/* Left: Form */}
        <div className="card">
          <div className="card-header">
            <h3>Campaign Details</h3>
          </div>
          <div style={{ padding: '1.5rem' }}>
            <form onSubmit={handleFormSubmit}>
              <div className="form-group">
                <label htmlFor="campaignName">Campaign Name *</label>
                <input
                  type="text"
                  id="campaignName"
                  placeholder="e.g., Q1 Product Launch Campaign"
                  value={campaignName}
                  onChange={(e) => setCampaignName(e.target.value)}
                  disabled={loading}
                  style={{ fontSize: '0.9rem' }}
                />
                <span style={{ fontSize: '0.8rem', color: 'var(--color-text-muted)', marginTop: '0.5rem', display: 'block' }}>
                  Choose a descriptive name to easily identify this campaign
                </span>
              </div>

              <div style={{ display: 'flex', gap: '0.75rem', marginTop: '2rem' }}>
                <button
                  type="button"
                  onClick={() => navigate('/campaigns')}
                  className="btn btn-ghost"
                  style={{ flex: 1 }}
                  disabled={loading}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{ flex: 1 }}
                  disabled={loading}
                >
                  {loading ? 'Creating...' : 'Create & Continue'}
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* Right: Tips Panel */}
        <div className="campaign-tips-panel">
          <h4>What to expect</h4>
          <ul className="campaign-tips-list">
            {tips.map((tip, i) => {
              const Icon = tip.icon
              return (
                <li key={i}>
                  <span className="tip-icon">
                    <Icon size={13} style={{ color: '#6366f1' }} />
                  </span>
                  <span>{tip.text}</span>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </div>
  )
}
